<template>
  <div>
    <Title
      :pages="[
        { icon: 'arrow-right', page: 'ASN' },
        { icon: '', page: page_title.toUpperCase() },
      ]"
    ></Title>
    <v-container fluid>
      <!-- HEADER ASN -->
      <v-row v-if="asn != null">
        <v-col class="px-5">
          <v-row align="center" class="mt-1 box-border">
            <v-col>
              <v-col class="v-col text-center text-button font-weight-bold pb-0"> ASN </v-col>
              <v-col class="text-center pt-0"> #{{ asn.id }} </v-col>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-col class="v-col text-center text-button font-weight-bold pb-0"> Cliente </v-col>
              <v-col class="text-center pt-0"> {{ asn.client.name }}</v-col>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-col class="v-col text-center text-button font-weight-bold pb-0"> Documento </v-col>
              <v-col class="text-center pt-0">{{ asn.document_type.name }} </v-col>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-col class="v-col text-center text-button font-weight-bold pb-0"> Fecha Estimada </v-col>
              <v-col class="text-center pt-0"> {{ asn.estimated_arrival_date }} </v-col>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
              <v-col class="v-col text-center text-button font-weight-bold pb-0"> Estado </v-col>
              <v-col class="text-center pt-0"> {{ asn.status.name }} </v-col>
            </v-col>
            <template v-if="showOrigenEntrega">
              <v-divider vertical></v-divider>
              <v-col>
                <v-col class="v-col text-center text-button font-weight-bold pb-0"> Origen devolución </v-col>
                <v-col class="text-center pt-0"> {{ asn.origen_entrega != null ? asn.origen_entrega.subclient.name : "-" }} </v-col>
              </v-col>
            </template>
            <template v-if="showRemitos">
              <v-divider vertical></v-divider>
              <v-col>
                <v-col class="v-col text-center text-button font-weight-bold pb-0"> Remitos/Facturas </v-col>
                <v-col class="text-center pt-0">
                  <template v-if="asn.has_remitos">
                    <v-chip v-for="remito in asn.remitos" :key="remito.id" size="small" class="ma-1">{{ remito.number }}</v-chip>
                  </template>
                  <template v-else>-</template>
                </v-col>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="asn != null && asn.asn_details_received.length == 0">
        <v-col class="px-5">
          <v-row>
            <v-col class="justify-content-center d-flex">
              <img src="@/assets/images/recibir.svg" alt="asn" class="img-fluid" width="400px" />
            </v-col>
          </v-row>

          <v-row v-if="asn.status.id != service.STATE_CERRADO">
            <v-col class="justify-content-center d-flex">
              <v-btn flat class="mb-3" color="green" @click="recibir()">Comenzar recepción</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="asn != null && asn.asn_details_received.length > 0">
        <v-col class="px-5">
          <v-row v-if="asn != null && asn.status.id != service.STATE_CERRADO">
            <v-col class="px-0 mb-2">
              <v-btn flat color="green" @click="recibir()">Nueva recepción</v-btn>
            </v-col>
            <v-col class="px-0 mb-2 justify-content-end d-flex">
              <v-btn flat color="blue-grey-lighten-3" border size="small" @click="openCloseDialog">Finalizar recepción</v-btn>
            </v-col>
          </v-row>
          <v-row class="mt-2 header-grey">
            <v-col class="p-0 justify-content-center d-flex text-button font-weight-bold font-12"> Producto </v-col>
            <v-divider vertical></v-divider>
            <v-col class="p-0 justify-content-center d-flex text-button font-weight-bold font-12"> Recepcion </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="1" class="p-0 justify-content-center d-flex text-button font-weight-bold font-12"> Cant. </v-col>
            <v-divider vertical></v-divider>
            <v-col class="p-0 justify-content-center d-flex text-button font-weight-bold font-12"> Estado </v-col>
            <v-divider vertical></v-divider>
            <v-col class="p-0 justify-content-center d-flex text-button font-weight-bold font-12"> LPN </v-col>
            <v-divider vertical></v-divider>
            <v-col class="p-0 justify-content-center d-flex text-button font-weight-bold font-12"> Atributos </v-col>
            <v-divider vertical></v-divider>
            <v-col class="p-0 justify-content-center d-flex text-button font-weight-bold font-12"> Observacion </v-col>
            <v-divider vertical></v-divider>
            <v-col class="p-0 justify-content-center d-flex text-button font-weight-bold font-12"> Acciones </v-col>
          </v-row>

          <v-row v-for="(item, index) in asn.asn_details_received" :key="index" class="mt-4 box-border">
            <v-col class="justify-content-center d-flex font-14">
              <div>
                <div>{{ item.presentation_atributes.product_presentation.product.name }}</div>
                <div class="text-caption text-grey-600">SKU: {{ item.presentation_atributes.product_presentation.product.sku }}</div>
              </div>
            </v-col>
            <v-col class="justify-content-center d-flex font-14"> {{ item.accepted ? "Aceptada" : "Rechazada - " + item.motivo }} </v-col>
            <v-col cols="1" class="justify-content-center d-flex font-14 nowrap">
              {{ item.amount }}
              {{ getPresentationTypeName(item.amount, item.presentation_atributes.product_presentation.presentation_type.id, item.presentation_atributes.product_presentation.presentation_type.name) }}
            </v-col>
            <v-col class="justify-content-center d-flex font-14">
              <v-chip size="small" :color="getStatusColor(item.presentation_atributes.product_status.id)" v-if="item.accepted">
                <b>{{ item.presentation_atributes.product_status.name }}</b>
              </v-chip>
              <div v-else>-</div>
            </v-col>
            <v-col class="font-14">
              <p class="font-weight-medium mb-0">{{ item.accepted ? item.lpn.code : "-" }}</p>
              <v-chip v-if="item.lpn != null" size="small" class="mt-1">{{ item.lpn.state.name }}</v-chip>
            </v-col>

            <v-col class="justify-content-center d-flex font-14">
              <div v-if="getInfoExtra(item).length > 0">
                <div v-for="(attribute, attrIndex) in getInfoExtra(item)" :key="attrIndex" class="text-caption">
                  {{ attribute }}
                </div>
              </div>
              <div v-else>-</div>
            </v-col>
            <v-col class="justify-content-center d-flex font-14"> {{ item.observations }} </v-col>
            <v-col class="justify-content-center d-flex font-14">
              <v-tooltip bottom>
                <template v-slot:activator="{ props }">
                  <v-icon v-if="item.photos && item.photos.length > 0" v-bind="props" small color="blue" class="mr-2" v-on:click="viewPhotos(item)" size="small">mdi-image-multiple </v-icon>
                </template>
                <span>Ver imágenes</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ props }">
                  <v-icon v-if="item.lpn" v-bind="props" small color="purple" class="mr-2" v-on:click="openPrintWitnessLpn(item)" size="small">mdi-printer </v-icon>
                </template>
                <span>Imprimir etiqueta testigo</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ props }">
                  <v-icon v-if="delete_access && asn != null && asn.status.id != service.STATE_CERRADO" v-bind="props" small color="red" class="mr-2" v-on:click="dialogDelete(item)" size="small"
                    >mdi-delete
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <ModalRecepcion :asn="asn" :dialog="dialog_recepcion" @updateDialog="dialog_recepcion = false" @loadList="getASN()" />

    <ModalPrintWitness 
      :show="dialog_print_witness" 
      :asn="asn"
      :lpn="selected_lpn" 
      :type="'lpn'"
      @close="dialog_print_witness = false" 
    />

    <ModalViewImages :dialog="dialog_photos" :photos="selected_photos" @updateDialog="dialog_photos = false" />

    <v-dialog :modelValue="dialog_close" :max-width="close_summary_items.length > 0 ? '900px' : '450px'" @click:outside="cancelCloseDialog" @keydown.esc="cancelCloseDialog">
      <v-card>
        <v-card-title class="headline">Confirmar cierre ASN</v-card-title>

        <v-card-text>
          <p class="mt-2 mb-3 fs-16">¿Estas seguro que quieres cerrar la ASN?</p>

          <v-autocomplete
            v-if="requireSubclient"
            v-model="subclient_selected"
            :items="subclients"
            item-title="name"
            item-value="id"
            label="Origen de la devolución*"
            autocomplete="off"
            clearable
            :error-messages="subclient_selected == null ? ['Debe seleccionar el origen'] : []"
            :loading="loading_subclients"
            class="mb-3"
          ></v-autocomplete>

          <v-combobox
            v-if="enableRemitos"
            v-model="remitos"
            label="Remitos/Facturas"
            hint="Escribí el número y presioná Enter"
            persistent-hint
            multiple
            chips
            closable-chips
            clearable
            autocomplete="off"
            :rules="[remitosRule]"
            class="mb-3"
          ></v-combobox>

          <v-data-table
            v-if="close_summary_items.length > 0"
            :headers="close_summary_headers"
            :items="close_summary_items"
            :items-per-page="10"
            style="border: 1px solid grey"
          >
            <template v-slot:item="{ item }">
              <tr :class="hasDifference(item) ? 'bg-warning-lighten' : ''">
                <td>{{ item.product_sku || '-' }}</td>
                <td>{{ item.product_name || '-' }}</td>
                <td>{{ item.expected_amount || 0 }}</td>
                <td>{{ item.base_amount_received || 0 }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="cancelCloseDialog">No</v-btn>
          <v-btn color="green darken-1" text :loading="loading_close" :disabled="(requireSubclient && subclient_selected == null) || remitosRule(remitos) !== true" @click="closeASN">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogYesNo
      :open="dialog_delete"
      :loading="loading_delete"
      title="Confirmar"
      message="¿Estas seguro que quieres eliminar la recepcion?"
      @cancel="dialog_delete = false"
      @accept="deleteRecepcion"
    />
  </div>
</template>

<script>
import { asnService } from "@/libs/ws/asnService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import ModalRecepcion from "./ModalRecepcion.vue";
import ModalPrintWitness from "./ModalPrintWitness.vue";
import ModalViewImages from "@/components/ModalViewImages.vue";
import { productoService } from "@/libs/ws/productoService";
import { subClientService } from "@/libs/ws/subClientService";

const DOCUMENT_TYPE_DEVOLUCION_CODE = "DEV";

export default {
  components: { ModalRecepcion, ModalPrintWitness, ModalViewImages },
  mixins: [GenericMixin, RolMixin, AliasMixin],
  data() {
    return {
      service: asnService,
      page_title: "Recepcion",
      dialog_recepcion: false,
      dialog_close: false,
      close_summary_items: [],
      subclients: [],
      subclient_selected: null,
      remitos: [],
      loading_subclients: false,
      close_summary_headers: [
        { title: "SKU", key: "product_sku" },
        { title: "Producto", key: "product_name" },
        { title: "Cant. esperada", key: "expected_amount" },
        { title: "Cant. recibida", key: "base_amount_received" },
      ],
      asn: null,

      dialog_delete: false,
      loading_delete: false,
      item_selected: null,
      dialog_photos: false,
      selected_photos: [],
      
      dialog_print_witness: false,
      selected_lpn: null,
    };
  },
  computed: {
    isDevolucion() {
      return this.asn?.document_type?.code === DOCUMENT_TYPE_DEVOLUCION_CODE;
    },
    requireSubclient() {
      return this.isDevolucion && this.asn?.client?.require_subclient_asn_devolucion === true;
    },
    enableRemitos() {
      return this.asn?.client?.enable_asn_remitos === true;
    },
    isClosed() {
      return this.asn?.status?.id == this.service.STATE_CERRADO;
    },
    //Datos informados en el cierre: se muestran si el cliente los usa o si el ASN los tiene cargados
    showOrigenEntrega() {
      return this.isClosed && this.isDevolucion && (this.asn?.client?.require_subclient_asn_devolucion === true || this.asn?.origen_entrega != null);
    },
    showRemitos() {
      return this.isClosed && (this.enableRemitos || this.asn?.has_remitos === true);
    },
  },
  mounted() {
    this.getASN();
  },
  methods: {
    hasDifference(item) {
      const expected = parseFloat(String(item.expected_amount ?? 0).replace(",", ".")) || 0;
      const received = parseFloat(String(item.base_amount_received ?? 0).replace(",", ".")) || 0;
      return expected !== received;
    },
    loadSubclients() {
      this.loading_subclients = true;
      subClientService
        .filter({ client: this.asn.client.id })
        .then((response) => {
          this.subclients = response?.result?.list || [];
        })
        .catch(() => {
          this.subclients = [];
        })
        .finally(() => {
          this.loading_subclients = false;
        });
    },
    openCloseDialog() {
      this.subclient_selected = null;
      if (this.requireSubclient) {
        this.loadSubclients();
      }
      asnService
        .getSummary({ id: this.$route.params.id })
        .then((response) => {
          this.close_summary_items = (response?.result || []).map((item) => ({
            product_sku: item.product_sku || item.product?.sku,
            product_name: item.product_name || item.product?.name,
            expected_amount: item.expected_amount ?? item.total_expected_amount ?? 0,
            base_amount_received: item.base_amount_received ?? 0,
          }));
          this.dialog_close = true;
        })
        .catch(() => {
          this.close_summary_items = [];
          this.dialog_close = true;
        });
    },
    cancelCloseDialog() {
      this.dialog_close = false;
      this.close_summary_items = [];
      this.subclient_selected = null;
      this.remitos = [];
    },
    remitosRule(value) {
      return (value || []).every((remito) => String(remito).trim().length <= 60) || "Cada remito/factura puede tener hasta 60 caracteres";
    },
    //No se llama close() para no pisar el close() de GenericMixin, que se dispara con Escape
    closeASN() {
      this.loading_close = true;

      const param = { id: this.$route.params.id };
      if (this.requireSubclient && this.subclient_selected != null) {
        param.subclient_id = this.subclient_selected;
      }
      if (this.enableRemitos && this.remitos.length > 0) {
        param.remitos = this.remitos.map((remito) => String(remito));
      }

      asnService
        .close(param)
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg);
            this.$router.back();
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((error) => {
          this.toast.error(error);
        })
        .finally(() => {
          this.loading_close = false;
          this.dialog_close = false;
          this.close_summary_items = [];
          this.subclient_selected = null;
          this.remitos = [];
        });
    },
    getInfoExtra(item) {
      var attributes = [];

      if (item.presentation_atributes.expiration_date != null) {
        attributes.push("Venc.: " + item.presentation_atributes.expiration_date);
      }
      if (item.presentation_atributes.manufacture_date != null) {
        attributes.push("Fabricacion: " + item.presentation_atributes.manufacture_date);
      }
      if (item.presentation_atributes.lote != null) {
        attributes.push("Lote: " + item.presentation_atributes.lote);
      }
      if (item.presentation_atributes.serie != null) {
        attributes.push("Serie: " + item.presentation_atributes.serie);
      }
      if (item.presentation_atributes.quality != null) {
        attributes.push("Calidad: " + item.presentation_atributes.quality.name);
      }
      if (item.presentation_atributes.descriptivo_1 != null && this.isAliasEnabled("descriptivo_1")) {
        attributes.push(this.getAliasName("descriptivo_1") + ": " + item.presentation_atributes.descriptivo_1);
      }
      if (item.presentation_atributes.descriptivo_2 != null && this.isAliasEnabled("descriptivo_2")) {
        attributes.push(this.getAliasName("descriptivo_2") + ": " + item.presentation_atributes.descriptivo_2);
      }
      if (item.presentation_atributes.descriptivo_3 != null && this.isAliasEnabled("descriptivo_3")) {
        attributes.push(this.getAliasName("descriptivo_3") + ": " + item.presentation_atributes.descriptivo_3);
      }
      if (item.presentation_atributes.storage_units_amount != null && item.presentation_atributes.storage_units_amount > 0) {
        attributes.push("Unidades de almacenamiento: " + item.presentation_atributes.storage_units_amount + " " + item.presentation_atributes.product_presentation.product.storage_unit.name);
      }

      return attributes;
    },
    getASN() {
      asnService.get({ id: this.$route.params.id }).then((response) => {
        this.asn = response.result;
      });
    },
    recibir() {
      this.dialog_recepcion = true;
    },
    dialogDelete(item) {
      this.item_selected = item;
      this.dialog_delete = true;
    },
    deleteRecepcion() {
      this.loading_delete = true;
      asnService
        .deleteDetailReceived({ id: this.item_selected.id })
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg);
            this.getASN();
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((error) => {
          this.toast.error(error);
        })
        .finally(() => {
          this.loading_delete = false;
          this.dialog_delete = false;
        });
    },
    viewPhotos(item) {
      this.selected_photos = item.photos || [];
      this.dialog_photos = true;
    },
    openPrintWitnessLpn(item) {
      if (item.lpn) {
        this.selected_lpn = item.lpn;
        this.dialog_print_witness = true;
      }
    },
    getStatusColor(status) {
      switch (parseInt(status)) {
        case productoService.PRODUCT_STATUS_DISPONIBLE:
          return "success";
        case productoService.PRODUCT_STATUS_BLOQUEADO:
          return "warning";
        case productoService.PRODUCT_STATUS_CUARENTENA:
          return "info";
        case productoService.PRODUCT_STATUS_VENCIDO:
          return "error";
        default:
          return "primary";
      }
    },
  },
};
</script>

<style scoped>
.bg-warning-lighten {
  background-color: #fff3cd !important;
}

.bg-warning-lighten:hover {
  background-color: #ffe69c !important;
}
</style>
